export const clearError = (errorsState, field) => {
    if (errorsState[field]) {
        delete errorsState[field];
    }
};
